
import { Image } from "element-ui"
import inputNumber from "./input-number.vue"
import { WARE_STATUS } from "@/constants/ware"
import emptyImg from "@/assets/images/empty_img.png"
import { handleAddToCartV2 } from "@/utils/cartResponse"
import { showGlobalMessage, openNoAddressPop, formatWareImgUrl, noAddressCheck, getDeliveryMethod } from "@/utils/utils"
import { trackAddToCart, trackSelectItem, handleChangeCartNumber } from "@/utils/track"

export default {
  name: "WareViewWare",
  components: {
    [Image.name]: Image,
    inputNumber
  },
  inject: {
    getStoreId: {
      default: null
    },
    source: {
      default: null
    },
    hideProTag: {
      default: false
    }
  },
  props: {
    defaultCount: {
      type: [String, Number],
      default: 0
    },
    info: {
      type: Object,
      default: () => ({
        wareImg: "",
        warePrice: "",
        wareName: ""
      })
    },
    defaultMax: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {
      config: {},
      max: 99,
      count: 0,
      commonReqParams: {},
      deliveryMethod: "clickCollect"
    }
  },
  computed: {
    showSoldTag() {
      return [WARE_STATUS.OUT_OF_STOCK, WARE_STATUS.DISCONTINUED].includes(this.config.wareStatus)
    },
    showProTag() {
      return (
        this.config.promotionWareVO.promotionInfoList &&
        this.config.promotionWareVO.promotionInfoList.length &&
        this.config.promotionWareVO.promotionInfoList[0].displayInfo &&
        this.config.promotionWareVO.promotionInfoList[0].displayInfo.proTag
      )
    },
    hasMutiProTag() {
      return (
        this.config.promotionWareVO.promotionInfoList &&
        this.config.promotionWareVO.promotionInfoList.length &&
        this.config.promotionWareVO.promotionInfoList.length > 1
      )
    },
    proDisplayTag() {
      return (
        this.config.promotionWareVO.promotionInfoList[0].displayInfo &&
        this.config.promotionWareVO.promotionInfoList[0].displayInfo.proTag
      )
    },
    imageUrl() {
      const imgUrl = this.config.wareImg
      if (imgUrl) {
        return formatWareImgUrl(imgUrl)
      }
      return emptyImg
    },
    detailLink() {
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${this.config.sku}&name=${encodeURIComponent(
        this.config.wareName
      )}`
    },
    isComingSoon() {
      return this.config.wareStatus === WARE_STATUS.COMING_SOON
    },
    isShowSimilar() {
      return this.config.wareStatus === WARE_STATUS.OUT_OF_STOCK || this.config.wareStatus === WARE_STATUS.DISCONTINUED
    },
    addCartText() {
      if (this.isComingSoon) {
        return this.$t("common.comingSoon")
      } else if (this.isShowSimilar) {
        return this.$t("common.findSimilar")
      } else {
        return this.$t("common.addToCart")
      }
    }
  },
  watch: {
    defaultCount: {
      handler(newVal) {
        if (newVal !== 0) {
          this.count = newVal
        }
      },
      immediate: true
    },
    defaultMax: {
      handler(newVal) {
        this.max = newVal
      },
      immediate: true
    },
    info: {
      handler(newVal) {
        console.log("info", newVal)
        this.config = newVal
      },
      immediate: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    this.deliveryMethod = getDeliveryMethod()
    const { commonReqParams } = this.$commonParams
    this.storeId = this.getStoreId ? this.getStoreId() : commonReqParams.storeId
  },

  methods: {
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    handleNumChange(val) {
      handleChangeCartNumber(val, this.count, this.config)
      this.count = val
    },
    async handleAdd() {
      if (this.isShowSimilar) {
        window.location.href = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?skuId=${this.config.sku}`
        return
      }

      // if (noAddressCheck()) {
      //   openNoAddressPop()
      //   return
      // }

      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data, wareList] = await handleAddToCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.config.sku, beforeCount: 0, count: 1, checked: 1 }],
        sort: 1
      })
      // if (error) {
      //   if (error.code == "44999") {
      //     openNoAddressPop()
      //   } else {
      //     // this.$message.error(error.result)
      //   }
      // }
      if (data) {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
        this.count = 1
      }
      if (wareList) {
        const item = wareList.find(v => v.skuId === this.config.sku)
        this.max = item && item.stock ? item.stock : 99
      }
      loading.close()
      trackAddToCart(this.config)
    },
    trackSelectItem
  }
}
